import { DragOverlay } from '@dnd-kit/core'
import type { FC } from 'react'
import { useMemo } from 'react'
import { draggingCueAtom } from '../store/dnd.store'
import { useAtomValue } from 'jotai'
import { Cue } from '../../cue/ui/cue'

export const DraggingCueOverlay: FC = () => {
  const draggingCue = useAtomValue(draggingCueAtom)

  const Overlay = useMemo(() => {
    if (!draggingCue) return null

    return <Cue cueId={draggingCue.id} />
  }, [draggingCue])

  return <DragOverlay>{Overlay}</DragOverlay>
}
